const capitalizeString = (string) => {
  if (typeof string !== 'string') return ''

  // Trim leading/trailing spaces and punctuation
  const cleanStr = string.trim().replace(/^[^a-zA-Z0-9]+/, '')

  if (cleanStr.includes(' ')) {
    return cleanStr
      .toLowerCase()
      .split(' ')
      .filter(Boolean)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  return cleanStr.charAt(0).toUpperCase() + cleanStr.slice(1).toLowerCase()
}

export default capitalizeString
